import { render, staticRenderFns } from "./LogoButtons.vue?vue&type=template&id=bbca0756&scoped=true"
var script = {}
import style0 from "./LogoButtons.vue?vue&type=style&index=0&id=bbca0756&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbca0756",
  null
  
)

export default component.exports